type ABTestConfig = {
	[K in string]: {
		testId: number;
		name: K;
		// order of variants must be strict for deterministic seeding
		variants: string[];
		defaultVariantIndex: number;
	};
};

// ABTest VM Web documentation: https://docs.google.com/spreadsheets/d/1Uic66C5htMJsHDovNdAFGPnxF4EFVc5X7GgM0lAFbU0
export const ABTEST_CONFIG = {
	couleur_boxmap: {
		testId: 1000,
		name: 'couleur_boxmap',
		variants: ['blanc', 'orange'],
		defaultVariantIndex: 0,
	},
} as const satisfies ABTestConfig;

export type ABTestName = keyof typeof ABTEST_CONFIG;
